"use client"

import { ReactNode, useRef } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

// The chat launcher is fixed bottom-right (48 px at right: 20px, so it spans the 20-68 px strip at the right edge).
// Hidden on /setup wherever a step's primary button reaches that strip (SetupHelpLink shows a "Chat with us" line
// instead, at exactly the same widths):
// - below 992 px (Tailwind lg) every step is one column as wide as the screen and step 1 has a fixed full-width
//   Continue bar, so the launcher sits on the Continue / pay button;
// - on the full-width steps (plan choice and card form, SetupLayout's data-setup-wide) the three plan cards fill
//   the max-w-5xl (1024 px) column, so their buttons reach the strip until (w + 1024) / 2 <= w - 68, i.e. 1160 px;
//   hidden below 1176 px for an 8 px gap. Own rule so a browser without :has() still applies the first one.
// From those widths the form sits left of the launcher (narrow steps: left 55 % column, launcher over the
// testimonial panel). Hidden on /setup only (this layout wraps nothing else); Intercom stays available everywhere else.
const LAUNCHER = ["#intercom-facade-btn", ".intercom-lightweight-app-launcher", ".intercom-launcher-frame", ".intercom-launcher", 'iframe[name="intercom-launcher-frame"]']
const HIDE_LAUNCHER_WHERE_IT_COVERS_THE_FORM = `@media (max-width: 991px) {
  ${LAUNCHER.join(",\n  ")} { display: none !important; }
}
@media (max-width: 1175px) {
  ${LAUNCHER.map((s) => `:root:has([data-setup-wide]) ${s}`).join(",\n  ")} { display: none !important; }
}`

export function SetupClientProviders({ children }: { children: ReactNode }) {
    const queryClientRef = useRef<QueryClient | null>(null)
    if (!queryClientRef.current) {
        queryClientRef.current = new QueryClient()
    }
    return (
        <QueryClientProvider client={queryClientRef.current}>
            <style>{HIDE_LAUNCHER_WHERE_IT_COVERS_THE_FORM}</style>
            {children}
        </QueryClientProvider>
    )
}
